export const __SearchLang = {
    input_placeholder: 'خدمت خود را جستجو کنید ...',
    history_title: 'تاریخچه جستجو',
    delete_btn: 'حذف',
};
